package com.essntl.uikit.resources

import androidx.compose.runtime.staticCompositionLocalOf

val LocalRes = staticCompositionLocalOf<EsResources> {
    error("Not implemented yet!")
}